import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex'

import FranchiseProductLibrary from '@/view/franchise/FranchiseProductLibrary.vue'
import ProductList from '@/view/store/ProductList.vue'


export default {
  __name: 'ProductLibraryRoute',
  setup(__props) {

const store = useStore()
const isFranchise = computed(() => store.getters.isFranchise)

return (_ctx, _cache) => {
  return (isFranchise.value)
    ? (_openBlock(), _createBlock(FranchiseProductLibrary, { key: 0 }))
    : (_openBlock(), _createBlock(ProductList, { key: 1 }))
}
}

}